/**
 * Z-index tiers for Brand Sets surfaces. The shared modal shell sits at the default Tippy
 * tier (9000ish); popovers/tooltips opened from inside it must sit above the shell, hence
 * the higher OVER_MODAL band.
 */
export const Z_TOOLTIP = 9000;
export const Z_TOOLTIP_OVER_MODAL = 99999;
